import { type SVGProps } from 'react'

export function ClipboardIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#fff'

  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_107081)">
        <path
          d="M10.593 2.816c.603 0 .904 0 1.152.066.67.18 1.195.704 1.375 1.375.066.247.066.549.066 1.151v5.963c0 1.09 0 1.634-.212 2.05a1.945 1.945 0 0 1-.85.85c-.416.211-.96.211-2.05.211H5.928c-1.09 0-1.634 0-2.05-.211a1.945 1.945 0 0 1-.85-.85c-.212-.416-.212-.96-.212-2.05V5.408c0-.602 0-.904.067-1.151a1.944 1.944 0 0 1 1.375-1.375c.247-.066.548-.066 1.151-.066m.648 7.13 1.296 1.296 2.917-2.917M6.445 4.112h3.111c.363 0 .545 0 .683-.07a.648.648 0 0 0 .284-.284c.07-.138.07-.32.07-.683v-.518c0-.363 0-.545-.07-.684a.648.648 0 0 0-.284-.283c-.138-.07-.32-.07-.683-.07h-3.11c-.364 0-.545 0-.684.07a.648.648 0 0 0-.283.283c-.071.14-.071.32-.071.684v.518c0 .363 0 .545.07.683a.648.648 0 0 0 .284.283c.139.071.32.071.683.071Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}
